import { initializeApp, getApps, getApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage"; // 1. Import Storage

const firebaseConfig = {
  apiKey: "AIzaSyCq-nFd9lZBXuWrJDeA5VKjLwce0u4Jq88",
  authDomain: "focusedtraderjournal.com",
  projectId: "tradezella-clone-46e0d",
  storageBucket: "tradezella-clone-46e0d.firebasestorage.app",
  messagingSenderId: "1047963183874",
  appId: "1:1047963183874:web:64bb3e1bda543cd231301b"
};

// Initialize Firebase (Checks if an app already exists to prevent re-initialization)
const app = !getApps().length ? initializeApp(firebaseConfig) : getApp();

// 2. Export the services
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
export const db = getFirestore(app);
export const storage = getStorage(app); // 3. Export Storage